/// <amd-module name="TFS/Admin/Common/RestClient/Graph" />
/**
 * ---------------------------------------------------------
 * Generated file, DO NOT EDIT
 * ---------------------------------------------------------
 *
 * See following wiki page for instructions on how to regenerate:
 *   https://aka.ms/azure-devops-client-generation
 *
 * Configuration file:
 *   vssf\client\webapi\httpclients\clientgeneratorconfigs\graph.genclient.json
 */

import { IVssPageContext, IVssRestClient, IVssRestClientOptions, RestClients } from "VSS/Platform/Context";
import { RestClientBase } from "VSS/Platform/RestClientBase";
import { deserializeVssJsonObject } from "VSS/Platform/Util/Serialization";

import * as VSS_Profile from "../Contracts/VSS.Profile";
import * as VSS_Graph_Contracts from "VSS/Platform/Contracts/Graph";
import * as VS_Services from "VSS/Platform/Contracts/WebApi";

export interface IGraphRestClient extends IVssRestClient {
    /**
     * @param subjectDescriptor - 
     */
    deleteAvatar(subjectDescriptor: string): Promise<void>;
    /**
     * @param subjectDescriptor - 
     * @param size - 
     * @param format - 
     */
    getAvatar(subjectDescriptor: string, size?: VSS_Profile.AvatarSize, format?: string): Promise<VSS_Profile.Avatar>;
    /**
     * @param avatar - 
     * @param subjectDescriptor - 
     */
    setAvatar(avatar: VSS_Profile.Avatar, subjectDescriptor: string): Promise<void>;
    /**
     */
    getCachePolicies(): Promise<VSS_Graph_Contracts.GraphCachePolicies>;
    /**
     * Resolve a storage key to a descriptor
     * 
     * @param storageKey - Storage key of the subject (user, group, scope, etc.) to resolve
     */
    getDescriptor(storageKey: string): Promise<VSS_Graph_Contracts.GraphDescriptorResult>;
    /**
     * Acquires the full set of federated provider authentication data available for the given graph subject and provider name.
     * 
     * @param subjectDescriptor - the descriptor of the graph subject that we should acquire data for
     * @param providerName - the name of the provider to acquire data for, e.g. "github.com"
     * @param versionHint - a version hint that can be used for optimistic cache concurrency and to support retries on access token failures; note that this is a hint only and does not guarantee a particular version on the response
     */
    getFederatedProviderData(subjectDescriptor: any, providerName: string, versionHint?: number): Promise<VSS_Graph_Contracts.GraphFederatedProviderData>;
    /**
     * Create a new Azure DevOps group or materialize an existing AAD group.
     * 
     * @param creationContext - The subset of the full graph group used to uniquely find the graph subject in an external provider.
     * @param scopeDescriptor - A descriptor referencing the scope (collection, project) in which the group should be created. If omitted, will be created in the scope of the enclosing account or organization. Valid only for VSTS groups.
     * @param groupDescriptors - A comma separated list of descriptors referencing groups you want the graph group to join
     */
    createGroup(creationContext: VSS_Graph_Contracts.GraphGroupCreationContext, scopeDescriptor?: string, groupDescriptors?: any[]): Promise<VSS_Graph_Contracts.GraphGroup>;
    /**
     * Removes an Azure DevOps group from all of its parent groups.
     * 
     * @param groupDescriptor - The descriptor of the group to delete.
     */
    deleteGroup(groupDescriptor: string): Promise<void>;
    /**
     * Get a group by its descriptor.
     * 
     * @param groupDescriptor - The descriptor of the desired graph group.
     */
    getGroup(groupDescriptor: string): Promise<VSS_Graph_Contracts.GraphGroup>;
    /**
     * Gets a list of all groups in the current scope (usually organization or account).
     * 
     * @param scopeDescriptor - Specify a non-default scope (collection, project) to search for groups.
     * @param subjectTypes - A comma separated list of user subject subtypes to reduce the retrieved results, e.g. Microsoft.IdentityModel.Claims.ClaimsIdentity
     * @param continuationToken - An opaque data blob that allows the next page of data to resume immediately after where the previous page ended. The only reliable way to know if there is more data left is the presence of a continuation token.
     */
    listGroups(scopeDescriptor?: string, subjectTypes?: string[], continuationToken?: string): Promise<VSS_Graph_Contracts.PagedGraphGroups>;
    /**
     * Update the properties of an Azure DevOps group.
     * 
     * @param groupDescriptor - The descriptor of the group to modify.
     * @param patchDocument - The JSON+Patch document containing the fields to alter.
     */
    updateGroup(groupDescriptor: string, patchDocument: VS_Services.JsonPatchDocument): Promise<VSS_Graph_Contracts.GraphGroup>;
    /**
     * Identity Translation - Translate endpoint is supposed to be used by geneva action.
     * 
     * @param masterId - 
     * @param localId - 
     */
    translate(masterId?: string, localId?: string): Promise<string>;
    /**
     * Gets all requested members in the current scope (usually organization or account).
     * 
     * @param memberLookup - 
     */
    lookupMembers(memberLookup: VSS_Graph_Contracts.GraphSubjectLookup): Promise<{ [key: string] : VSS_Graph_Contracts.GraphMember; }>;
    /**
     * Get a list of all members in a given scope.
     * 
     * @param continuationToken - An opaque data blob that allows the next page of data to resume immediately after where the previous page ended. The only reliable way to know if there is more data left is the presence of a continuation token.
     * @param subjectTypes - A comma separated list of user subject subtypes to reduce the retrieved results, e.g. ‘msa’, ‘aad’, ‘svc’ (service identity), ‘imp’ (imported identity), etc.
     * @param subjectKinds - A comma sepearted list of user subject subjectkinds to reduce the retrieved results, e.g. ‘user’, ‘servicePrincipal’
     * @param metaTypes - 
     * @param scopeDescriptor - Specify a non-default scope (collection, project) to search for users.
     */
    listMembers(continuationToken?: string, subjectTypes?: string[], subjectKinds?: string[], metaTypes?: string[], scopeDescriptor?: string): Promise<VSS_Graph_Contracts.PagedGraphMembers>;
    /**
     * This endpoint returns a result for any member that has ever been valid in the system, even if the member has since been deleted or has had all their memberships deleted. The current validity of the member is indicated through its disabled property, which is omitted when false.
     * 
     * @param memberDescriptor - The descriptor of the desired member.
     */
    getMemberByDescriptor(memberDescriptor: string): Promise<VSS_Graph_Contracts.GraphMember>;
    /**
     * Create a new membership between a container and subject.
     * 
     * @param subjectDescriptor - A descriptor to a group or user that can be the child subject in the relationship.
     * @param containerDescriptor - A descriptor to a group that can be the container in the relationship.
     */
    addMembership(subjectDescriptor: string, containerDescriptor: string): Promise<VSS_Graph_Contracts.GraphMembership>;
    /**
     * Check to see if a membership relationship between a container and subject exists.
     * 
     * @param subjectDescriptor - The group or user that is a child subject of the relationship.
     * @param containerDescriptor - The group that is the container in the relationship.
     */
    checkMembershipExistence(subjectDescriptor: string, containerDescriptor: string): Promise<boolean>;
    /**
     * Get a membership relationship between a container and subject.
     * 
     * @param subjectDescriptor - A descriptor to the child subject in the relationship.
     * @param containerDescriptor - A descriptor to the container in the relationship.
     */
    getMembership(subjectDescriptor: string, containerDescriptor: string): Promise<VSS_Graph_Contracts.GraphMembership>;
    /**
     * Deletes a membership between a container and subject.
     * 
     * @param subjectDescriptor - A descriptor to a group or user that is the child subject in the relationship.
     * @param containerDescriptor - A descriptor to a group that is the container in the relationship.
     */
    removeMembership(subjectDescriptor: string, containerDescriptor: string): Promise<void>;
    /**
     * Get all the memberships where this descriptor is a member in the relationship.
     * 
     * @param subjectDescriptor - Fetch all direct memberships of this descriptor.
     * @param direction - Defaults to Up.
     * @param depth - The maximum number of edges to traverse up or down the membership tree. Currently the only supported value is '1'.
     */
    listMemberships(subjectDescriptor: string, direction?: VSS_Graph_Contracts.GraphTraversalDirection, depth?: number): Promise<VSS_Graph_Contracts.GraphMembership[]>;
    /**
     * Check whether a subject is active or inactive.
     * 
     * @param subjectDescriptor - Descriptor of the subject (user, group, scope, etc.) to check state of
     */
    getMembershipState(subjectDescriptor: string): Promise<VSS_Graph_Contracts.GraphMembershipState>;
    /**
     * Traverse memberships of the given subject descriptors.
     * 
     * @param membershipTraversalLookup - Fetch the descendants/ancestors of the list of descriptors depending on direction.
     * @param direction - The default value is Unknown.
     * @param depth - The default value is '1'.
     */
    lookupMembershipTraversals(membershipTraversalLookup: VSS_Graph_Contracts.GraphSubjectLookup, direction?: VSS_Graph_Contracts.GraphTraversalDirection, depth?: number): Promise<{ [key: string] : VSS_Graph_Contracts.GraphMembershipTraversal; }>;
    /**
     * Traverse memberships of the given subject descriptor.
     * 
     * @param subjectDescriptor - Fetch the descendants/ancestors of this descriptor depending on direction.
     * @param direction - The default value is Unknown.
     * @param depth - The default value is '1'.
     */
    traverseMemberships(subjectDescriptor: string, direction?: VSS_Graph_Contracts.GraphTraversalDirection, depth?: number): Promise<VSS_Graph_Contracts.GraphMembershipTraversal>;
    /**
     * @param userDescriptor - 
     */
    getProviderInfo(userDescriptor: string): Promise<VSS_Graph_Contracts.GraphProviderInfo>;
    /**
     * @param jsondocument - 
     */
    requestAccess(jsondocument: any): Promise<void>;
    /**
     * Batch-map a list of users to new users.
     * 
     * @param mappings - A list of mappings.
     */
    resolve(mappings: VSS_Graph_Contracts.IdentityMappings): Promise<VSS_Graph_Contracts.ResolveDisconnectedUsersResponse>;
    /**
     * @param creationContext - 
     * @param scopeDescriptor - 
     */
    createScope(creationContext: VSS_Graph_Contracts.GraphScopeCreationContext, scopeDescriptor?: string): Promise<VSS_Graph_Contracts.GraphScope>;
    /**
     * @param scopeDescriptor - 
     */
    deleteScope(scopeDescriptor: string): Promise<void>;
    /**
     * Get a scope identified by its descriptor
     * 
     * @param scopeDescriptor - A descriptor that uniquely identifies a scope.
     */
    getScope(scopeDescriptor: string): Promise<VSS_Graph_Contracts.GraphScope>;
    /**
     * @param scopeDescriptor - 
     * @param patchDocument - 
     */
    updateScope(scopeDescriptor: string, patchDocument: VS_Services.JsonPatchDocument): Promise<void>;
    /**
     * Materialize an existing AAD service principal into the ADO account.
     * 
     * @param creationContext - The subset of the full graph service principal used to uniquely find the graph subject in an external provider.
     * @param groupDescriptors - A comma separated list of descriptors of groups you want the graph service principal to join
     */
    createServicePrincipal(creationContext: VSS_Graph_Contracts.GraphServicePrincipalCreationContext, groupDescriptors?: any[]): Promise<VSS_Graph_Contracts.GraphServicePrincipal>;
    /**
     * Disables a service principal.
     * 
     * @param servicePrincipalDescriptor - The descriptor of the service principal to delete.
     */
    deleteServicePrincipal(servicePrincipalDescriptor: string): Promise<void>;
    /**
     * Get a service principal by its descriptor.
     * 
     * @param servicePrincipalDescriptor - The descriptor of the desired service principal.
     */
    getServicePrincipal(servicePrincipalDescriptor: string): Promise<VSS_Graph_Contracts.GraphServicePrincipal>;
    /**
     * Get a list of all service principals in a given scope.
     * 
     * @param continuationToken - An opaque data blob that allows the next page of data to resume immediately after where the previous page ended. The only reliable way to know if there is more data left is the presence of a continuation token.
     * @param scopeDescriptor - Specify a non-default scope (collection, project) to search for service principals.
     */
    listServicePrincipals(continuationToken?: string, scopeDescriptor?: string): Promise<VSS_Graph_Contracts.PagedGraphServicePrincipals>;
    /**
     * Map an existing service principal to a different service principal.
     * 
     * @param updateContext - The subset of the full graph service principal used to uniquely find the graph subject in an external provider.
     * @param servicePrincipalDescriptor - The descriptor of the service principal to update
     */
    updateServicePrincipal(updateContext: VSS_Graph_Contracts.GraphServicePrincipalUpdateContext, servicePrincipalDescriptor: string): Promise<VSS_Graph_Contracts.GraphServicePrincipal>;
    /**
     * Resolve a descriptor to a storage key.
     * 
     * @param subjectDescriptor - 
     */
    getStorageKey(subjectDescriptor: string): Promise<VSS_Graph_Contracts.GraphStorageKeyResult>;
    /**
     * Resolve descriptors to users, groups or scopes (Subjects) in a batch.
     * 
     * @param subjectLookup - A list of descriptors that specifies a subset of subjects to retrieve. Each descriptor uniquely identifies the subject across all instance scopes, but only at a single point in time.
     */
    lookupSubjects(subjectLookup: VSS_Graph_Contracts.GraphSubjectLookup): Promise<{ [key: string] : VSS_Graph_Contracts.GraphSubject; }>;
    /**
     * Search for Azure Devops users, or/and groups. Results will be returned in a batch with no more than 100 graph subjects.
     * 
     * @param subjectQuery - The query that we'll be using to search includes the following: Query: the search term. The search will be prefix matching only. SubjectKind: "User" or "Group" can be specified, both or either ScopeDescriptor: Non-default scope can be specified, i.e. project scope descriptor
     */
    querySubjects(subjectQuery: VSS_Graph_Contracts.GraphSubjectQuery): Promise<VSS_Graph_Contracts.GraphSubject[]>;
    /**
     * Resolve a descriptor to a user, group or scope.
     * 
     * @param subjectDescriptor - The descriptor of the desired subject.
     */
    getSubject(subjectDescriptor: string): Promise<VSS_Graph_Contracts.GraphSubject>;
    /**
     * Materialize an existing AAD or MSA user into the ADO account.
     * 
     * @param creationContext - The subset of the full graph user used to uniquely find the graph subject in an external provider.
     * @param groupDescriptors - A comma separated list of descriptors of groups you want the graph user to join
     */
    createUser(creationContext: VSS_Graph_Contracts.GraphUserCreationContext, groupDescriptors?: any[]): Promise<VSS_Graph_Contracts.GraphUser>;
    /**
     * Disables a user.
     * 
     * @param userDescriptor - The descriptor of the user to delete.
     */
    deleteUser(userDescriptor: string): Promise<void>;
    /**
     * Get a user by its descriptor.
     * 
     * @param userDescriptor - The descriptor of the desired user.
     */
    getUser(userDescriptor: string): Promise<VSS_Graph_Contracts.GraphUser>;
    /**
     * Get a list of all users in a given scope.
     * 
     * @param subjectTypes - A comma separated list of user subject subtypes to reduce the retrieved results, e.g. msa’, ‘aad’, ‘svc’ (service identity), ‘imp’ (imported identity), etc.
     * @param continuationToken - An opaque data blob that allows the next page of data to resume immediately after where the previous page ended. The only reliable way to know if there is more data left is the presence of a continuation token.
     * @param scopeDescriptor - Specify a non-default scope (collection, project) to search for users.
     */
    listUsers(subjectTypes?: string[], continuationToken?: string, scopeDescriptor?: string): Promise<VSS_Graph_Contracts.PagedGraphUsers>;
    /**
     * Map an existing user to a different user.
     * 
     * @param updateContext - The subset of the full graph user used to uniquely find the graph subject in an external provider.
     * @param userDescriptor - The descriptor of the user to update
     */
    updateUser(updateContext: VSS_Graph_Contracts.GraphUserUpdateContext, userDescriptor: string): Promise<VSS_Graph_Contracts.GraphUser>;
}

class GraphRestClient extends RestClientBase implements IGraphRestClient {
    constructor(options: IVssRestClientOptions) {
        super(options);
    }

    /**
     * @param subjectDescriptor - 
     */
    public async deleteAvatar(
        subjectDescriptor: string
        ): Promise<void> {

        return this.beginRequest<void>({
            apiVersion: "7.1-preview.1",
            method: "DELETE",
            routeTemplate: "_apis/Graph/Subjects/{subjectDescriptor}/Avatars",
            routeValues: {
                subjectDescriptor: subjectDescriptor
            }
        });
    }

    /**
     * @param subjectDescriptor - 
     * @param size - 
     * @param format - 
     */
    public async getAvatar(
        subjectDescriptor: string,
        size?: VSS_Profile.AvatarSize,
        format?: string
        ): Promise<VSS_Profile.Avatar> {

        const queryValues: any = {
            size: size,
            format: format
        };

        return this.beginRequest<VSS_Profile.Avatar>({
            apiVersion: "7.1-preview.1",
            routeTemplate: "_apis/Graph/Subjects/{subjectDescriptor}/Avatars",
            routeValues: {
                subjectDescriptor: subjectDescriptor
            },
            queryParams: queryValues
        });
    }

    /**
     * @param avatar - 
     * @param subjectDescriptor - 
     */
    public async setAvatar(
        avatar: VSS_Profile.Avatar,
        subjectDescriptor: string
        ): Promise<void> {

        return this.beginRequest<void>({
            apiVersion: "7.1-preview.1",
            method: "PUT",
            routeTemplate: "_apis/Graph/Subjects/{subjectDescriptor}/Avatars",
            routeValues: {
                subjectDescriptor: subjectDescriptor
            },
            body: avatar
        });
    }

    /**
     */
    public async getCachePolicies(
        ): Promise<VSS_Graph_Contracts.GraphCachePolicies> {

        return this.beginRequest<VSS_Graph_Contracts.GraphCachePolicies>({
            apiVersion: "7.1-preview.1",
            routeTemplate: "_apis/Graph/CachePolicies"
        });
    }

    /**
     * Resolve a storage key to a descriptor
     * 
     * @param storageKey - Storage key of the subject (user, group, scope, etc.) to resolve
     */
    public async getDescriptor(
        storageKey: string
        ): Promise<VSS_Graph_Contracts.GraphDescriptorResult> {

        return this.beginRequest<VSS_Graph_Contracts.GraphDescriptorResult>({
            apiVersion: "7.1-preview.1",
            routeTemplate: "_apis/Graph/Descriptors/{storageKey}",
            routeValues: {
                storageKey: storageKey
            }
        });
    }

    /**
     * Acquires the full set of federated provider authentication data available for the given graph subject and provider name.
     * 
     * @param subjectDescriptor - the descriptor of the graph subject that we should acquire data for
     * @param providerName - the name of the provider to acquire data for, e.g. "github.com"
     * @param versionHint - a version hint that can be used for optimistic cache concurrency and to support retries on access token failures; note that this is a hint only and does not guarantee a particular version on the response
     */
    public async getFederatedProviderData(
        subjectDescriptor: any,
        providerName: string,
        versionHint?: number
        ): Promise<VSS_Graph_Contracts.GraphFederatedProviderData> {

        const queryValues: any = {
            providerName: providerName,
            versionHint: versionHint
        };

        return this.beginRequest<VSS_Graph_Contracts.GraphFederatedProviderData>({
            apiVersion: "7.1-preview.1",
            routeTemplate: "_apis/Graph/FederatedProviderData/{subjectDescriptor}",
            routeValues: {
                subjectDescriptor: subjectDescriptor
            },
            queryParams: queryValues
        });
    }

    /**
     * Create a new Azure DevOps group or materialize an existing AAD group.
     * 
     * @param creationContext - The subset of the full graph group used to uniquely find the graph subject in an external provider.
     * @param scopeDescriptor - A descriptor referencing the scope (collection, project) in which the group should be created. If omitted, will be created in the scope of the enclosing account or organization. Valid only for VSTS groups.
     * @param groupDescriptors - A comma separated list of descriptors referencing groups you want the graph group to join
     */
    public async createGroup(
        creationContext: VSS_Graph_Contracts.GraphGroupCreationContext,
        scopeDescriptor?: string,
        groupDescriptors?: any[]
        ): Promise<VSS_Graph_Contracts.GraphGroup> {

        const queryValues: any = {
            scopeDescriptor: scopeDescriptor,
            groupDescriptors: groupDescriptors && groupDescriptors.join(",")
        };

        return this.beginRequest<VSS_Graph_Contracts.GraphGroup>({
            apiVersion: "7.1-preview.1",
            method: "POST",
            routeTemplate: "_apis/Graph/Groups/{groupDescriptor}",
            queryParams: queryValues,
            body: creationContext
        });
    }

    /**
     * Removes an Azure DevOps group from all of its parent groups.
     * 
     * @param groupDescriptor - The descriptor of the group to delete.
     */
    public async deleteGroup(
        groupDescriptor: string
        ): Promise<void> {

        return this.beginRequest<void>({
            apiVersion: "7.1-preview.1",
            method: "DELETE",
            routeTemplate: "_apis/Graph/Groups/{groupDescriptor}",
            routeValues: {
                groupDescriptor: groupDescriptor
            }
        });
    }

    /**
     * Get a group by its descriptor.
     * 
     * @param groupDescriptor - The descriptor of the desired graph group.
     */
    public async getGroup(
        groupDescriptor: string
        ): Promise<VSS_Graph_Contracts.GraphGroup> {

        return this.beginRequest<VSS_Graph_Contracts.GraphGroup>({
            apiVersion: "7.1-preview.1",
            routeTemplate: "_apis/Graph/Groups/{groupDescriptor}",
            routeValues: {
                groupDescriptor: groupDescriptor
            }
        });
    }

    /**
     * Gets a list of all groups in the current scope (usually organization or account).
     * 
     * @param scopeDescriptor - Specify a non-default scope (collection, project) to search for groups.
     * @param subjectTypes - A comma separated list of user subject subtypes to reduce the retrieved results, e.g. Microsoft.IdentityModel.Claims.ClaimsIdentity
     * @param continuationToken - An opaque data blob that allows the next page of data to resume immediately after where the previous page ended. The only reliable way to know if there is more data left is the presence of a continuation token.
     */
    public async listGroups(
        scopeDescriptor?: string,
        subjectTypes?: string[],
        continuationToken?: string
        ): Promise<VSS_Graph_Contracts.PagedGraphGroups> {

        const queryValues: any = {
            scopeDescriptor: scopeDescriptor,
            subjectTypes: subjectTypes && subjectTypes.join(","),
            continuationToken: continuationToken
        };

        return this.beginRequest<Response>({
            apiVersion: "7.1-preview.1",
            routeTemplate: "_apis/Graph/Groups/{groupDescriptor}",
            queryParams: queryValues,
            returnRawResponse: true
        }).then(async response => {
            const body = await response.text().then(deserializeVssJsonObject);
            const continuationTokenHeader = response.headers.get("X-MS-ContinuationToken");
            const result: VSS_Graph_Contracts.PagedGraphGroups = {
                graphGroups: <VSS_Graph_Contracts.GraphGroup[]>body,
                continuationToken: continuationTokenHeader ? continuationTokenHeader.split(',') : []
            };
            return result;
        });
    }

    /**
     * Update the properties of an Azure DevOps group.
     * 
     * @param groupDescriptor - The descriptor of the group to modify.
     * @param patchDocument - The JSON+Patch document containing the fields to alter.
     */
    public async updateGroup(
        groupDescriptor: string,
        patchDocument: VS_Services.JsonPatchDocument
        ): Promise<VSS_Graph_Contracts.GraphGroup> {

        return this.beginRequest<VSS_Graph_Contracts.GraphGroup>({
            apiVersion: "7.1-preview.1",
            method: "PATCH",
            routeTemplate: "_apis/Graph/Groups/{groupDescriptor}",
            routeValues: {
                groupDescriptor: groupDescriptor
            },
            customHeaders: {
                "Content-Type": "application/json-patch+json",
            },
            body: patchDocument
        });
    }

    /**
     * Identity Translation - Translate endpoint is supposed to be used by geneva action.
     * 
     * @param masterId - 
     * @param localId - 
     */
    public async translate(
        masterId?: string,
        localId?: string
        ): Promise<string> {

        const queryValues: any = {
            masterId: masterId,
            localId: localId
        };

        return this.beginRequest<string>({
            apiVersion: "7.1-preview.1",
            routeTemplate: "_apis/Graph/IdentityTranslation",
            queryParams: queryValues
        });
    }

    /**
     * Gets all requested members in the current scope (usually organization or account).
     * 
     * @param memberLookup - 
     */
    public async lookupMembers(
        memberLookup: VSS_Graph_Contracts.GraphSubjectLookup
        ): Promise<{ [key: string] : VSS_Graph_Contracts.GraphMember; }> {

        return this.beginRequest<{ [key: string] : VSS_Graph_Contracts.GraphMember; }>({
            apiVersion: "7.1-preview.1",
            method: "POST",
            routeTemplate: "_apis/Graph/MemberLookup",
            body: memberLookup
        });
    }

    /**
     * Get a list of all members in a given scope.
     * 
     * @param continuationToken - An opaque data blob that allows the next page of data to resume immediately after where the previous page ended. The only reliable way to know if there is more data left is the presence of a continuation token.
     * @param subjectTypes - A comma separated list of user subject subtypes to reduce the retrieved results, e.g. ‘msa’, ‘aad’, ‘svc’ (service identity), ‘imp’ (imported identity), etc.
     * @param subjectKinds - A comma sepearted list of user subject subjectkinds to reduce the retrieved results, e.g. ‘user’, ‘servicePrincipal’
     * @param metaTypes - 
     * @param scopeDescriptor - Specify a non-default scope (collection, project) to search for users.
     */
    public async listMembers(
        continuationToken?: string,
        subjectTypes?: string[],
        subjectKinds?: string[],
        metaTypes?: string[],
        scopeDescriptor?: string
        ): Promise<VSS_Graph_Contracts.PagedGraphMembers> {

        const queryValues: any = {
            continuationToken: continuationToken,
            subjectTypes: subjectTypes && subjectTypes.join(","),
            subjectKinds: subjectKinds && subjectKinds.join(","),
            metaTypes: metaTypes && metaTypes.join(","),
            scopeDescriptor: scopeDescriptor
        };

        return this.beginRequest<Response>({
            apiVersion: "7.1-preview.2",
            routeTemplate: "_apis/Graph/Members",
            queryParams: queryValues,
            returnRawResponse: true
        }).then(async response => {
            const body = await response.text().then(deserializeVssJsonObject);
            const continuationTokenHeader = response.headers.get("X-MS-ContinuationToken");
            const result: VSS_Graph_Contracts.PagedGraphMembers = {
                graphMembers: <VSS_Graph_Contracts.GraphMember[]>body,
                continuationToken: continuationTokenHeader ? continuationTokenHeader.split(',') : []
            };
            return result;
        });
    }

    /**
     * This endpoint returns a result for any member that has ever been valid in the system, even if the member has since been deleted or has had all their memberships deleted. The current validity of the member is indicated through its disabled property, which is omitted when false.
     * 
     * @param memberDescriptor - The descriptor of the desired member.
     */
    public async getMemberByDescriptor(
        memberDescriptor: string
        ): Promise<VSS_Graph_Contracts.GraphMember> {

        return this.beginRequest<VSS_Graph_Contracts.GraphMember>({
            apiVersion: "7.1-preview.2",
            routeTemplate: "_apis/Graph/Members/{memberDescriptor}",
            routeValues: {
                memberDescriptor: memberDescriptor
            }
        });
    }

    /**
     * Create a new membership between a container and subject.
     * 
     * @param subjectDescriptor - A descriptor to a group or user that can be the child subject in the relationship.
     * @param containerDescriptor - A descriptor to a group that can be the container in the relationship.
     */
    public async addMembership(
        subjectDescriptor: string,
        containerDescriptor: string
        ): Promise<VSS_Graph_Contracts.GraphMembership> {

        return this.beginRequest<VSS_Graph_Contracts.GraphMembership>({
            apiVersion: "7.1-preview.1",
            method: "PUT",
            routeTemplate: "_apis/Graph/Memberships/{subjectDescriptor}/{containerDescriptor}",
            routeValues: {
                subjectDescriptor: subjectDescriptor,
                containerDescriptor: containerDescriptor
            }
        });
    }

    /**
     * Check to see if a membership relationship between a container and subject exists.
     * 
     * @param subjectDescriptor - The group or user that is a child subject of the relationship.
     * @param containerDescriptor - The group that is the container in the relationship.
     */
    public async checkMembershipExistence(
        subjectDescriptor: string,
        containerDescriptor: string
        ): Promise<boolean> {

        return this.beginRequest<Response>({
            apiVersion: "7.1-preview.1",
            method: "HEAD",
            routeTemplate: "_apis/Graph/Memberships/{subjectDescriptor}/{containerDescriptor}",
            routeValues: {
                subjectDescriptor: subjectDescriptor,
                containerDescriptor: containerDescriptor
            },
            returnRawResponse: true
        }).then(async response => {
            return true;
        }).catch((error) => {
            if (error.status === 404) {
                return false;
            }
            throw error;
        });
    }

    /**
     * Get a membership relationship between a container and subject.
     * 
     * @param subjectDescriptor - A descriptor to the child subject in the relationship.
     * @param containerDescriptor - A descriptor to the container in the relationship.
     */
    public async getMembership(
        subjectDescriptor: string,
        containerDescriptor: string
        ): Promise<VSS_Graph_Contracts.GraphMembership> {

        return this.beginRequest<VSS_Graph_Contracts.GraphMembership>({
            apiVersion: "7.1-preview.1",
            routeTemplate: "_apis/Graph/Memberships/{subjectDescriptor}/{containerDescriptor}",
            routeValues: {
                subjectDescriptor: subjectDescriptor,
                containerDescriptor: containerDescriptor
            }
        });
    }

    /**
     * Deletes a membership between a container and subject.
     * 
     * @param subjectDescriptor - A descriptor to a group or user that is the child subject in the relationship.
     * @param containerDescriptor - A descriptor to a group that is the container in the relationship.
     */
    public async removeMembership(
        subjectDescriptor: string,
        containerDescriptor: string
        ): Promise<void> {

        return this.beginRequest<void>({
            apiVersion: "7.1-preview.1",
            method: "DELETE",
            routeTemplate: "_apis/Graph/Memberships/{subjectDescriptor}/{containerDescriptor}",
            routeValues: {
                subjectDescriptor: subjectDescriptor,
                containerDescriptor: containerDescriptor
            }
        });
    }

    /**
     * Get all the memberships where this descriptor is a member in the relationship.
     * 
     * @param subjectDescriptor - Fetch all direct memberships of this descriptor.
     * @param direction - Defaults to Up.
     * @param depth - The maximum number of edges to traverse up or down the membership tree. Currently the only supported value is '1'.
     */
    public async listMemberships(
        subjectDescriptor: string,
        direction?: VSS_Graph_Contracts.GraphTraversalDirection,
        depth?: number
        ): Promise<VSS_Graph_Contracts.GraphMembership[]> {

        const queryValues: any = {
            direction: direction,
            depth: depth
        };

        return this.beginRequest<VSS_Graph_Contracts.GraphMembership[]>({
            apiVersion: "7.1-preview.1",
            routeTemplate: "_apis/Graph/Memberships/{subjectDescriptor}",
            routeValues: {
                subjectDescriptor: subjectDescriptor
            },
            queryParams: queryValues
        });
    }

    /**
     * Check whether a subject is active or inactive.
     * 
     * @param subjectDescriptor - Descriptor of the subject (user, group, scope, etc.) to check state of
     */
    public async getMembershipState(
        subjectDescriptor: string
        ): Promise<VSS_Graph_Contracts.GraphMembershipState> {

        return this.beginRequest<VSS_Graph_Contracts.GraphMembershipState>({
            apiVersion: "7.1-preview.1",
            routeTemplate: "_apis/Graph/MembershipStates/{subjectDescriptor}",
            routeValues: {
                subjectDescriptor: subjectDescriptor
            }
        });
    }

    /**
     * Traverse memberships of the given subject descriptors.
     * 
     * @param membershipTraversalLookup - Fetch the descendants/ancestors of the list of descriptors depending on direction.
     * @param direction - The default value is Unknown.
     * @param depth - The default value is '1'.
     */
    public async lookupMembershipTraversals(
        membershipTraversalLookup: VSS_Graph_Contracts.GraphSubjectLookup,
        direction?: VSS_Graph_Contracts.GraphTraversalDirection,
        depth?: number
        ): Promise<{ [key: string] : VSS_Graph_Contracts.GraphMembershipTraversal; }> {

        const queryValues: any = {
            direction: direction,
            depth: depth
        };

        return this.beginRequest<{ [key: string] : VSS_Graph_Contracts.GraphMembershipTraversal; }>({
            apiVersion: "7.1-preview.1",
            method: "POST",
            routeTemplate: "_apis/Graph/MembershipTraversals/{subjectDescriptor}",
            queryParams: queryValues,
            body: membershipTraversalLookup
        });
    }

    /**
     * Traverse memberships of the given subject descriptor.
     * 
     * @param subjectDescriptor - Fetch the descendants/ancestors of this descriptor depending on direction.
     * @param direction - The default value is Unknown.
     * @param depth - The default value is '1'.
     */
    public async traverseMemberships(
        subjectDescriptor: string,
        direction?: VSS_Graph_Contracts.GraphTraversalDirection,
        depth?: number
        ): Promise<VSS_Graph_Contracts.GraphMembershipTraversal> {

        const queryValues: any = {
            direction: direction,
            depth: depth
        };

        return this.beginRequest<VSS_Graph_Contracts.GraphMembershipTraversal>({
            apiVersion: "7.1-preview.1",
            routeTemplate: "_apis/Graph/MembershipTraversals/{subjectDescriptor}",
            routeValues: {
                subjectDescriptor: subjectDescriptor
            },
            queryParams: queryValues
        });
    }

    /**
     * @param userDescriptor - 
     */
    public async getProviderInfo(
        userDescriptor: string
        ): Promise<VSS_Graph_Contracts.GraphProviderInfo> {

        return this.beginRequest<VSS_Graph_Contracts.GraphProviderInfo>({
            apiVersion: "7.1-preview.1",
            routeTemplate: "_apis/Graph/Users/{userDescriptor}/ProviderInfo",
            routeValues: {
                userDescriptor: userDescriptor
            }
        });
    }

    /**
     * @param jsondocument - 
     */
    public async requestAccess(
        jsondocument: any
        ): Promise<void> {

        return this.beginRequest<void>({
            apiVersion: "7.1-preview.1",
            method: "POST",
            routeTemplate: "_apis/Graph/RequestAccess",
            body: jsondocument
        });
    }

    /**
     * Batch-map a list of users to new users.
     * 
     * @param mappings - A list of mappings.
     */
    public async resolve(
        mappings: VSS_Graph_Contracts.IdentityMappings
        ): Promise<VSS_Graph_Contracts.ResolveDisconnectedUsersResponse> {

        return this.beginRequest<VSS_Graph_Contracts.ResolveDisconnectedUsersResponse>({
            apiVersion: "7.1-preview.1",
            method: "POST",
            routeTemplate: "_apis/Graph/ResolveDisconnectedUsers",
            body: mappings
        });
    }

    /**
     * @param creationContext - 
     * @param scopeDescriptor - 
     */
    public async createScope(
        creationContext: VSS_Graph_Contracts.GraphScopeCreationContext,
        scopeDescriptor?: string
        ): Promise<VSS_Graph_Contracts.GraphScope> {

        return this.beginRequest<VSS_Graph_Contracts.GraphScope>({
            apiVersion: "7.1-preview.1",
            method: "POST",
            routeTemplate: "_apis/Graph/Scopes/{scopeDescriptor}",
            routeValues: {
                scopeDescriptor: scopeDescriptor
            },
            body: creationContext
        });
    }

    /**
     * @param scopeDescriptor - 
     */
    public async deleteScope(
        scopeDescriptor: string
        ): Promise<void> {

        return this.beginRequest<void>({
            apiVersion: "7.1-preview.1",
            method: "DELETE",
            routeTemplate: "_apis/Graph/Scopes/{scopeDescriptor}",
            routeValues: {
                scopeDescriptor: scopeDescriptor
            }
        });
    }

    /**
     * Get a scope identified by its descriptor
     * 
     * @param scopeDescriptor - A descriptor that uniquely identifies a scope.
     */
    public async getScope(
        scopeDescriptor: string
        ): Promise<VSS_Graph_Contracts.GraphScope> {

        return this.beginRequest<VSS_Graph_Contracts.GraphScope>({
            apiVersion: "7.1-preview.1",
            routeTemplate: "_apis/Graph/Scopes/{scopeDescriptor}",
            routeValues: {
                scopeDescriptor: scopeDescriptor
            }
        });
    }

    /**
     * @param scopeDescriptor - 
     * @param patchDocument - 
     */
    public async updateScope(
        scopeDescriptor: string,
        patchDocument: VS_Services.JsonPatchDocument
        ): Promise<void> {

        return this.beginRequest<void>({
            apiVersion: "7.1-preview.1",
            method: "PATCH",
            routeTemplate: "_apis/Graph/Scopes/{scopeDescriptor}",
            routeValues: {
                scopeDescriptor: scopeDescriptor
            },
            customHeaders: {
                "Content-Type": "application/json-patch+json",
            },
            body: patchDocument
        });
    }

    /**
     * Materialize an existing AAD service principal into the ADO account.
     * 
     * @param creationContext - The subset of the full graph service principal used to uniquely find the graph subject in an external provider.
     * @param groupDescriptors - A comma separated list of descriptors of groups you want the graph service principal to join
     */
    public async createServicePrincipal(
        creationContext: VSS_Graph_Contracts.GraphServicePrincipalCreationContext,
        groupDescriptors?: any[]
        ): Promise<VSS_Graph_Contracts.GraphServicePrincipal> {

        const queryValues: any = {
            groupDescriptors: groupDescriptors && groupDescriptors.join(",")
        };

        return this.beginRequest<VSS_Graph_Contracts.GraphServicePrincipal>({
            apiVersion: "7.1-preview.1",
            method: "POST",
            routeTemplate: "_apis/Graph/ServicePrincipals/{servicePrincipalDescriptor}",
            queryParams: queryValues,
            body: creationContext
        });
    }

    /**
     * Disables a service principal.
     * 
     * @param servicePrincipalDescriptor - The descriptor of the service principal to delete.
     */
    public async deleteServicePrincipal(
        servicePrincipalDescriptor: string
        ): Promise<void> {

        return this.beginRequest<void>({
            apiVersion: "7.1-preview.1",
            method: "DELETE",
            routeTemplate: "_apis/Graph/ServicePrincipals/{servicePrincipalDescriptor}",
            routeValues: {
                servicePrincipalDescriptor: servicePrincipalDescriptor
            }
        });
    }

    /**
     * Get a service principal by its descriptor.
     * 
     * @param servicePrincipalDescriptor - The descriptor of the desired service principal.
     */
    public async getServicePrincipal(
        servicePrincipalDescriptor: string
        ): Promise<VSS_Graph_Contracts.GraphServicePrincipal> {

        return this.beginRequest<VSS_Graph_Contracts.GraphServicePrincipal>({
            apiVersion: "7.1-preview.1",
            routeTemplate: "_apis/Graph/ServicePrincipals/{servicePrincipalDescriptor}",
            routeValues: {
                servicePrincipalDescriptor: servicePrincipalDescriptor
            }
        });
    }

    /**
     * Get a list of all service principals in a given scope.
     * 
     * @param continuationToken - An opaque data blob that allows the next page of data to resume immediately after where the previous page ended. The only reliable way to know if there is more data left is the presence of a continuation token.
     * @param scopeDescriptor - Specify a non-default scope (collection, project) to search for service principals.
     */
    public async listServicePrincipals(
        continuationToken?: string,
        scopeDescriptor?: string
        ): Promise<VSS_Graph_Contracts.PagedGraphServicePrincipals> {

        const queryValues: any = {
            continuationToken: continuationToken,
            scopeDescriptor: scopeDescriptor
        };

        return this.beginRequest<Response>({
            apiVersion: "7.1-preview.1",
            routeTemplate: "_apis/Graph/ServicePrincipals/{servicePrincipalDescriptor}",
            queryParams: queryValues,
            returnRawResponse: true
        }).then(async response => {
            const body = await response.text().then(deserializeVssJsonObject);
            const continuationTokenHeader = response.headers.get("X-MS-ContinuationToken");
            const result: VSS_Graph_Contracts.PagedGraphServicePrincipals = {
                graphServicePrincipals: <VSS_Graph_Contracts.GraphServicePrincipal[]>body,
                continuationToken: continuationTokenHeader ? continuationTokenHeader.split(',') : []
            };
            return result;
        });
    }

    /**
     * Map an existing service principal to a different service principal.
     * 
     * @param updateContext - The subset of the full graph service principal used to uniquely find the graph subject in an external provider.
     * @param servicePrincipalDescriptor - The descriptor of the service principal to update
     */
    public async updateServicePrincipal(
        updateContext: VSS_Graph_Contracts.GraphServicePrincipalUpdateContext,
        servicePrincipalDescriptor: string
        ): Promise<VSS_Graph_Contracts.GraphServicePrincipal> {

        return this.beginRequest<VSS_Graph_Contracts.GraphServicePrincipal>({
            apiVersion: "7.1-preview.1",
            method: "PATCH",
            routeTemplate: "_apis/Graph/ServicePrincipals/{servicePrincipalDescriptor}",
            routeValues: {
                servicePrincipalDescriptor: servicePrincipalDescriptor
            },
            body: updateContext
        });
    }

    /**
     * Resolve a descriptor to a storage key.
     * 
     * @param subjectDescriptor - 
     */
    public async getStorageKey(
        subjectDescriptor: string
        ): Promise<VSS_Graph_Contracts.GraphStorageKeyResult> {

        return this.beginRequest<VSS_Graph_Contracts.GraphStorageKeyResult>({
            apiVersion: "7.1-preview.1",
            routeTemplate: "_apis/Graph/StorageKeys/{subjectDescriptor}",
            routeValues: {
                subjectDescriptor: subjectDescriptor
            }
        });
    }

    /**
     * Resolve descriptors to users, groups or scopes (Subjects) in a batch.
     * 
     * @param subjectLookup - A list of descriptors that specifies a subset of subjects to retrieve. Each descriptor uniquely identifies the subject across all instance scopes, but only at a single point in time.
     */
    public async lookupSubjects(
        subjectLookup: VSS_Graph_Contracts.GraphSubjectLookup
        ): Promise<{ [key: string] : VSS_Graph_Contracts.GraphSubject; }> {

        return this.beginRequest<{ [key: string] : VSS_Graph_Contracts.GraphSubject; }>({
            apiVersion: "7.1-preview.1",
            method: "POST",
            routeTemplate: "_apis/Graph/SubjectLookup",
            body: subjectLookup
        });
    }

    /**
     * Search for Azure Devops users, or/and groups. Results will be returned in a batch with no more than 100 graph subjects.
     * 
     * @param subjectQuery - The query that we'll be using to search includes the following: Query: the search term. The search will be prefix matching only. SubjectKind: "User" or "Group" can be specified, both or either ScopeDescriptor: Non-default scope can be specified, i.e. project scope descriptor
     */
    public async querySubjects(
        subjectQuery: VSS_Graph_Contracts.GraphSubjectQuery
        ): Promise<VSS_Graph_Contracts.GraphSubject[]> {

        return this.beginRequest<VSS_Graph_Contracts.GraphSubject[]>({
            apiVersion: "7.1-preview.1",
            method: "POST",
            routeTemplate: "_apis/Graph/SubjectQuery",
            body: subjectQuery
        });
    }

    /**
     * Resolve a descriptor to a user, group or scope.
     * 
     * @param subjectDescriptor - The descriptor of the desired subject.
     */
    public async getSubject(
        subjectDescriptor: string
        ): Promise<VSS_Graph_Contracts.GraphSubject> {

        return this.beginRequest<VSS_Graph_Contracts.GraphSubject>({
            apiVersion: "7.1-preview.1",
            routeTemplate: "_apis/Graph/Subjects/{subjectDescriptor}",
            routeValues: {
                subjectDescriptor: subjectDescriptor
            }
        });
    }

    /**
     * Materialize an existing AAD or MSA user into the ADO account.
     * 
     * @param creationContext - The subset of the full graph user used to uniquely find the graph subject in an external provider.
     * @param groupDescriptors - A comma separated list of descriptors of groups you want the graph user to join
     */
    public async createUser(
        creationContext: VSS_Graph_Contracts.GraphUserCreationContext,
        groupDescriptors?: any[]
        ): Promise<VSS_Graph_Contracts.GraphUser> {

        const queryValues: any = {
            groupDescriptors: groupDescriptors && groupDescriptors.join(",")
        };

        return this.beginRequest<VSS_Graph_Contracts.GraphUser>({
            apiVersion: "7.1-preview.1",
            method: "POST",
            routeTemplate: "_apis/Graph/Users/{userDescriptor}",
            queryParams: queryValues,
            body: creationContext
        });
    }

    /**
     * Disables a user.
     * 
     * @param userDescriptor - The descriptor of the user to delete.
     */
    public async deleteUser(
        userDescriptor: string
        ): Promise<void> {

        return this.beginRequest<void>({
            apiVersion: "7.1-preview.1",
            method: "DELETE",
            routeTemplate: "_apis/Graph/Users/{userDescriptor}",
            routeValues: {
                userDescriptor: userDescriptor
            }
        });
    }

    /**
     * Get a user by its descriptor.
     * 
     * @param userDescriptor - The descriptor of the desired user.
     */
    public async getUser(
        userDescriptor: string
        ): Promise<VSS_Graph_Contracts.GraphUser> {

        return this.beginRequest<VSS_Graph_Contracts.GraphUser>({
            apiVersion: "7.1-preview.1",
            routeTemplate: "_apis/Graph/Users/{userDescriptor}",
            routeValues: {
                userDescriptor: userDescriptor
            }
        });
    }

    /**
     * Get a list of all users in a given scope.
     * 
     * @param subjectTypes - A comma separated list of user subject subtypes to reduce the retrieved results, e.g. msa’, ‘aad’, ‘svc’ (service identity), ‘imp’ (imported identity), etc.
     * @param continuationToken - An opaque data blob that allows the next page of data to resume immediately after where the previous page ended. The only reliable way to know if there is more data left is the presence of a continuation token.
     * @param scopeDescriptor - Specify a non-default scope (collection, project) to search for users.
     */
    public async listUsers(
        subjectTypes?: string[],
        continuationToken?: string,
        scopeDescriptor?: string
        ): Promise<VSS_Graph_Contracts.PagedGraphUsers> {

        const queryValues: any = {
            subjectTypes: subjectTypes && subjectTypes.join(","),
            continuationToken: continuationToken,
            scopeDescriptor: scopeDescriptor
        };

        return this.beginRequest<Response>({
            apiVersion: "7.1-preview.1",
            routeTemplate: "_apis/Graph/Users/{userDescriptor}",
            queryParams: queryValues,
            returnRawResponse: true
        }).then(async response => {
            const body = await response.text().then(deserializeVssJsonObject);
            const continuationTokenHeader = response.headers.get("X-MS-ContinuationToken");
            const result: VSS_Graph_Contracts.PagedGraphUsers = {
                graphUsers: <VSS_Graph_Contracts.GraphUser[]>body,
                continuationToken: continuationTokenHeader ? continuationTokenHeader.split(',') : []
            };
            return result;
        });
    }

    /**
     * Map an existing user to a different user.
     * 
     * @param updateContext - The subset of the full graph user used to uniquely find the graph subject in an external provider.
     * @param userDescriptor - The descriptor of the user to update
     */
    public async updateUser(
        updateContext: VSS_Graph_Contracts.GraphUserUpdateContext,
        userDescriptor: string
        ): Promise<VSS_Graph_Contracts.GraphUser> {

        return this.beginRequest<VSS_Graph_Contracts.GraphUser>({
            apiVersion: "7.1-preview.1",
            method: "PATCH",
            routeTemplate: "_apis/Graph/Users/{userDescriptor}",
            routeValues: {
                userDescriptor: userDescriptor
            },
            body: updateContext
        });
    }

}

export const GraphClientName = "IGraphRestClient";

export function getGraphClient(pageContext: IVssPageContext, options?: IVssRestClientOptions): IGraphRestClient {
    return pageContext.getRestClient<IGraphRestClient>(GraphClientName, options);
}

RestClients.add(GraphClientName, { 
    factory: GraphRestClient,
    options: {
        resourceAreaId: "bb1e7ec9-e901-4b68-999a-de7012b920f8",
        serviceInstanceType: "951917ac-a960-4999-8464-e3f0aa25b381"
    }
});
